import Header from "./components/Header";
import GreyLink from "./components/GreyLink";
import Meta from "../../components/Meta";
import WalletCheckout from "../../wallet/WalletCheckout";

const ExperienceWalletCheckout = () => {
	return (
		<>
			<Meta title="Top Up Wallet" />
			<Header
				heading={"Top Up Wallet"}
				subHeading={"Choose a wallet package"}
				button={<GreyLink to={"/account/wallet"} label={"Back to Wallet"} />}
			/>
			<div className={"container mx-auto p-6 pt-0 grid grid-cols-1 gap-4"}>
				<WalletCheckout basePath="/account/wallet" />
			</div>
		</>
	);
};

export default ExperienceWalletCheckout;
